import { VersionService } from "@services/version.service";
import * as angular from "angular";
import "./loginPage.component.scss";

class ComponentController implements angular.IComponentController {

    appVersion = "";

    winter = false;
    showSnow = false;
    showDots = false;

    // ----

    static $inject = ["versionService"];

    constructor(private versionService: VersionService) {
    }

    $onInit(): void {
        const monthOfYear = new Date().getMonth();

        this.winter = monthOfYear < 4 || monthOfYear > 9;
        this.showSnow = monthOfYear == 11;

        this.showDots = !this.showSnow;

        // Prevents animations and video showing on slow computers
        const numCores = navigator["hardwareConcurrency"] || 2;
        if (numCores <= 4) {
            this.showDots = false;
            this.showSnow = false;
        }

        this.versionService.getAPIVersion()
            .then(version => {
                this.appVersion = version;
            })
            .catch(angular.noop);
    }

    getInTouch() {
        window.open("https://www.addsecure.com/contact-support/", '_blank').focus();
    }

    // ---

}

export class LoginPageComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {


        this.bindings = {};

        this.controller = ComponentController;
        this.template = require("./loginPage.component.html");
    }
}
